import { useTranslation } from 'react-i18next';
import { useGetLocaleFormatsQuery, useGetUiSettingsQuery } from '@casops/store/apis/settingsApi';
import { DrawerPanel } from '@dmc/ui';
import SettingsForm from './components/form/SettingsForm';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { ReactElement } from 'react';

// Load all of the API data dependencies here before rendering the form.
export function ManageSettingsPanel(): ReactElement {
  const { t } = useTranslation();

  const { currentData: settings, isSuccess: isSuccessSettings } = useGetUiSettingsQuery();

  const { currentData: localeFormats, isSuccess: isSuccessLocaleFormats } =
    useGetLocaleFormatsQuery();

  // Combine the loaded state of the main data model with any additional data needed for the form.
  const isLoaded = [settings, isSuccessSettings, localeFormats, isSuccessLocaleFormats].every(
    Boolean,
  );

  // Base the renderKey on all data that can change.
  const renderKey = useRenderKey({ settings, localeFormats });

  return (
    <DrawerPanel isLoaded={isLoaded} header={t('EditSettings')}>
      <SettingsForm key={renderKey} settings={settings} />
    </DrawerPanel>
  );
}

export default ManageSettingsPanel;
